//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import { uid, extend } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    name: "ExposeApiActionRules",
    components: {
        draggable,
        setConditions,
        AQModal,
        AQButton,
        AQInput,
        AQChip,
        AQDialog,
        AQCard
    },
    props: {
        defaultPathBeforeSave: String,
        actionRuleProp: Array
    },
    data() {
        return {
            defaultModal: false,
            actionRulesModal: false,
            actionRulesArray: [],
            search: "",
            extendParent: false,
            showVariablesCard: false,
            list: null,
            invalidName: false,
            pathSelected: false,
            hasClose: true,
            actionRulePath: null,
            conditions: null,
            objectLabel: [],
            defaultPathArray: [],
            defaultValue: null,
            selectPath: null,
            valueSelected: false,
            isDisable: false,
            cloneAction: {},
            actionIsInEdit: false,
            actionNewAdd: false,
            drag: false,
            defaultPathDlg: false,
            addActionRuleDlg: false,
            editActionRuleDlg: false,
            headerActionsModel: [
                {
                    id: "deleteRule",
                    name: this.$t("diagrams.components.setRules.delete")
                }],
            currentAction: {
                name: "",
                description: "",
                conditions: {},
                path: "",
                index: ""
            }
        };
    },
    computed: {
        ...mapGetters("diagrams", [
            "diagramData",
            "selectedPluginUuid",
            "selectedPluginConfigData"
        ]),
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: this.isDisable
            };
        },
        showHeaderActions() {
            return this.actionIsInEdit
                ? [{
                    label: this.$t("diagrams.components.setRules.delete"),
                    id: "deleteRule"
                }]
                : [];
        },

        getTitleForButton() {
            return this.defaultValue ? `${this.$t("diagrams.components.exposeApi.default")} ${this.defaultValue}`
                : this.$t("diagrams.components.exposeApi.titleModalDefault");
        },

        selectPathValue() {
            return this.valueSelected;
        },

        computedDefaultPathArray() {
            return this.selectActionPath();
        },

        computedRulesPathArray() {
            return this.selectActionPath();
        }
    },
    watch: {
        actionIsInEdit: {
            handler(value) {
                if (value) {
                    this.hasPrimary = { label: this.$t("diagrams.components.exposeApi.updateBtn"), color: "positive" };
                } else {
                    this.hasPrimary = { label: this.$t("diagrams.components.exposeApi.addBtn"), color: "positive" };
                }
            },
            immediate: true
        },
        conditions: {
            deep: true,
            handler(value) {
                if (value && value.conditions.length && this.checkValidConditions() && this.currentAction.name && this.actionRulePath) {
                    this.isDisable = false;
                } else {
                    this.isDisable = true;
                }
            }
        }
    },
    mounted() {
        this.createDefaultPath();
        this.actionRulesArray = this.actionRuleProp && this.actionRuleProp.length ? this.actionRuleProp : [];
    },

    methods: {
        afterHide() {
            this.$emit("input", false);
        },
        changeClass() {
            this.valueSelected = true;
            this.pathSelected = true;
            if (this.defaultModal) {
                this.isDisable = false;
            }
            if (this.actionRulesModal) {
                this.currentAction.path = this.actionRulePath;
                if (this.currentAction && this.currentAction.name && this.checkValidConditions()) {
                    this.isDisable = false;
                } else {
                    this.isDisable = true;
                }
            }
        },
        setData() {
            this.defaultModal = true;
            this.list = this.selectPath;
            this.isDisable = true;
        },
        selectActionPath() {
            let results = [];
            const lowerCaseValue = this.search.toLowerCase();
            results = this.defaultPathArray.filter(item => (item.name
                ? item.name.toLowerCase().includes(lowerCaseValue)
                : false));
            return results;
        },

        hasValue() {
            if (this.currentAction.name && this.actionRulePath && this.checkValidConditions()) {
                this.isDisable = false;
            } else {
                this.isDisable = true;
            }
        },

        updateDescription() {
            if (this.actionIsInEdit) {
                this.isDisable = false;
            }
        },

        getTitle() {
            return this.defaultValue || this.$t("diagrams.components.exposeApi.titleModalDefault");
        },

        createDefaultPath() {
            if (this.diagramData.connectors.length > 0) {
                this.defaultPathArray = [];
                const object = this.diagramData.connectors;
                for (let k = 0; k < object.length; k++) {
                    if (object[k].from === this.selectedPluginUuid) {
                        for (let j = 0; j < this.diagramData.content.length; j++) {
                            if (object[k].to === this.diagramData.content[j].uuid) {
                                const elem = this.diagramData.content[j];
                                const objectLabel = [];
                                objectLabel.push({
                                    label: `[${this.$t(`diagrams.components.exposeApi.${elem.id}CODE`)}-${this.returnNumber(elem)}] ${elem.label.value}`,
                                    sublabel: this.$t(`diagrams.components.exposeApi.${elem.id}NAME`),
                                    name: elem.label.value
                                });

                                this.defaultPathArray.push({
                                    label: objectLabel[0].label,
                                    subLabel: objectLabel[0].sublabel,
                                    data: this.diagramData.content[j],
                                    uuid: object[k].uuid,
                                    name: objectLabel[0].name
                                });
                            }
                        }
                    }
                }
            }
            if (
                this.selectedPluginConfigData
        && this.selectedPluginConfigData.apiConfigure
        && !this.defaultPathBeforeSave
            ) {
                const sentDefaultpath = this.selectedPluginConfigData.apiConfigure
                    .defaultPath;
                this.sendDataToParent(sentDefaultpath, false);
            } else if (this.defaultPathBeforeSave) {
                const sentDefaultpath = this.defaultPathBeforeSave;
                this.sendDataToParent(sentDefaultpath, false);
            }
        },
        changeOrder() {
            this.$emit("sendActionRules", this.actionRulesArray);
        },

        sendDataToParent(value, param) {
            let sendData = null;
            for (let i = 0; i < this.defaultPathArray.length; i++) {
                if (this.defaultPathArray[i].uuid === value) {
                    this.defaultValue = this.defaultPathArray[i].label;
                    this.selectPath = this.defaultPathArray[i];
                    param = true;
                    this.getTitle();
                }
            }
            sendData = param ? value : null;
            this.$emit("send", sendData);
        },

        returnNumber(elem) {
            let nr = 1;
            if (this.defaultPathArray && this.defaultPathArray.length > 0) {
                for (let i = 0; i < this.defaultPathArray.length; i++) {
                    if (
                        this.defaultPathArray[i].data.id === elem.id
            && this.defaultPathArray[i].data.uuid !== elem.uuid
                    ) {
                        nr++;
                    }
                }
            }
            return nr;
        },

        action(action) {
            if (action === "primary") {
                this.$emit("send", this.list);
                this.defaultValue = this.list.label;
                this.selectPath = this.list;
                this.defaultModal = false;
            } else if (action === "close") {
                if (!this.isDisable) {
                    if ((this.selectedPluginConfigData && this.selectedPluginConfigData.apiConfigure
                        && this.selectedPluginConfigData.apiConfigure.defaultPath) !== (this.list && this.list.uuid)) {
                        this.defaultPathDlg = true;
                    } else {
                        this.defaultModal = false;
                    }
                } else {
                    this.defaultModal = false;
                }
            }
            this.search = "";
        },

        actionRule(action) {
            if (action === "primary") {
                if (this.actionIsInEdit) {
                    this.actionRulesArray.find(el => {
                        if (el.index === this.currentAction.index) {
                            this.currentAction.uuid = this.currentAction.uuid || uid();
                            this.currentAction.conditions = this.conditions;
                            this.currentAction.path = this.actionRulePath.uuid;
                            el = this.currentAction;
                        }
                        return false;
                    });
                } else {
                    this.currentAction.uuid = this.currentAction.uuid || uid();
                    this.currentAction.index = this.actionRulesArray.length;
                    this.currentAction.conditions = this.conditions;
                    this.currentAction.path = this.actionRulePath.uuid;
                    this.actionRulesArray.push(this.currentAction);
                }
                this.actionRulesModal = false;
                this.$emit("sendActionRules", this.actionRulesArray);
            } else if (action === this.$t("diagrams.components.setRules.delete")) {
                this.actionRulesArray.splice(this.actionRulesArray.indexOf(this.currentAction), 1);
                this.$emit("sendActionRules", this.actionRulesArray);
                this.actionRulesModal = false;
            } else if (action === "close") {
                if (this.actionNewAdd && !this.isDisable) {
                    this.addActionRuleDlg = true;
                } else if (this.actionIsInEdit && !this.isDisable) {
                    this.editActionRuleDlg = true;
                } else {
                    this.actionRulesModal = false;
                }
            }
            this.isDisable = false;
            this.search = "";
        },
        editActionRuleOk() {
            this.actionRulesArray.find(el => {
                if (el.index === this.currentAction.index) {
                    this.actionRulesArray[el.index] = this.cloneAction;
                }
                return false;
            });
            this.actionRulesModal = false;
        },
        addAction() {
            this.search = "";
            this.actionRulesModal = true;
            this.isDisable = true;
            this.actionIsInEdit = false;
            this.actionNewAdd = true;
            this.conditions = null;
            this.actionRulePath = null;
            this.currentAction = {
                name: "",
                description: "",
                conditions: {},
                path: "",
                index: ""
            };
            this.$root.$emit("showDataModel", false);
        },

        editAction(indexEdit) {
            this.cloneAction = {};
            this.isDisable = true;
            this.actionRulesArray.find(el => {
                if (el.index === indexEdit) {
                    this.currentAction = el;
                    this.conditions = el.conditions;
                    this.cloneAction = extend(true, {}, el);
                }
                return false;
            });
            this.computedRulesPathArray.find(element => {
                if (element.uuid === this.currentAction.path) {
                    this.actionRulePath = element;
                }
                return false;
            });
            this.actionIsInEdit = true;
            this.actionNewAdd = false;
            this.actionRulesModal = true;
            this.$root.$emit("showDataModel", false);
        },
        // metoda care verifica conditiile care vin din set-levels sa nu fie empty
        checkValidConditions() {
            let isValid = true;
            if (this.conditions && !this.conditions.conditions.length) {
                isValid = false;
            }
            this.conditions.conditions.forEach(condition => {
                if (condition.type === "condition" && (!condition.val1.value || !condition.val2.value)) {
                    isValid = false;
                }
            });
            if (JSON.stringify(this.cloneAction) === JSON.stringify(this.currentAction)) {
                isValid = false;
            }
            return isValid;
        }
    }
};
